import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faEdit } from '@fortawesome/free-solid-svg-icons';
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../src/assets/css/magnific-popup.css'
import '../src/assets/css/magnific-popup.css'
import '../src/assets/css/font-awesome.min.css'
import '../src/assets/css/custom-animated.css'
import '../src/assets/css/default.css'
import '../src/assets/css/style.css'
import '../src/assets/css/main.css'
import axios from 'axios';
import Toasted from 'vue-toasted';
import vmodal from 'vue-js-modal';


import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);
import smoothscroll from 'smoothscroll-polyfill';

// Apply the polyfill
smoothscroll.polyfill();
// library.add(faEdit);

// Vue.component('font-awesome-icon', FontAwesomeIcon);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false


Vue.use(Toasted);
Vue.use(vmodal);

export async function callAxios(url, data = {}, method = 'get') {
  try {
    const response = await axios({
      url,
      method,
      data,
      // ... other axios options
    });
    return response.data;
  } catch (error) {
    console.error('Error in Axios request:', error);
    throw error; // Propagate the error
  }
}

export async function callAxiosWithConfig(url, data = {}, method = 'get') {
  try {
    const response = await axios({
      url,
      method,
      data,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error in Axios request:', error);
    throw error; // Propagate the error
  }
}

export async function callAxiosWithHeader(url, data = {}, method = 'get', header = {}) {
  try {
    const tokenHeader = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    };
    var finalHeader = { ...tokenHeader, ...header};
    // header
    const response = await axios({
      url,
      method,
      data,
      headers: finalHeader
    });
    return response.data;
  } catch (error) {
    console.error('Error in Axios request:', error);
    throw error; // Propagate the error
  }
}
axios.interceptors.response.use(
    response => response,
    async error => {
      if (error.response && error.response.status === 401) {
        // Handle 401 status
        localStorage.removeItem('customerCare');
        localStorage.removeItem('token');
        localStorage.removeItem('titleWord');
        localStorage.removeItem('SideMenu');
        localStorage.removeItem('homeurl');
        // Redirect to a certain route, for example, the login page
        await router.push('/');
        return Promise.resolve();
      }
      return Promise.reject(error);
    }
);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
